<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="佣金补扣单号" name="sup_deduct_number"></c-form-item>
					<c-form-item type="select" label="补扣类型" name="type" :options="Type"></c-form-item>
					<c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="State" ></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_member_reward_supdeduct_edit"  @click="add">申请补扣款</c-button>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			
			<c-table ref="table" code="member_reward_supdeduct_list">
				<c-table-column
					label="佣金补扣单号"
					name="sup_deduct_number"
		          width="150"
		        ></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
                  width="70"
                >
					<template v-slot="{data}">
                        <span style="color:red" v-if="data.state==0">{{stateName[data.state]}}</span>
                        <span style="color:dodgerblue" v-if="data.state==1">{{stateName[data.state]}}</span>
                        <span style="color:dodgerblue" v-if="data.state==2">{{stateName[data.state]}}</span>
                        <span style="color:green" v-if="data.state==3">{{stateName[data.state]}}</span>
                        <span style="color:gray" v-if="data.state==4">{{stateName[data.state]}}</span>
					</template>
				</c-table-column>

                <c-table-column
                    label="类型"
                    name="type"
                    width="50"
                >
                  <template v-slot="{data}">
                    <span style="color:dodgerblue"  v-if="data.type=='补款'">{{data.type}}</span>
                    <span style="color:red"  v-if="data.type=='扣款'">{{data.type}}</span>
                  </template>
                </c-table-column>

				<c-table-column
					label="金额"
					name="money"
                    width="110"
                >
                  <template v-slot="{data}">
                    <span style="color:dodgerblue" v-if="data.money && data.money>0">￥{{data.money.toFixed(2)}}</span>
                    <span v-else>--</span>
                  </template>
                </c-table-column>
				
				<c-table-column
					label="会员手机号"
					name="user_manage_mobilephone"
                    width="120"
                ></c-table-column>

                <c-table-column
                        label="会员头像/昵称"
                        name="head_photo"
                        width="140"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>
				

				<c-table-column
					label="备注"
					name="remark"
                  width="150"
                ></c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
                  width="150"
                ></c-table-column>
				
				<c-table-column
					label="申请人姓名"
					name="create_user_realname"
                    width="120"
                ></c-table-column>

				<c-table-column
					label="审批人姓名"
					name="approval_user_realname"
					width="120"
				></c-table-column>

				<c-table-column
					label="审批时间"
					name="approval_date"
                    width="150"
                ></c-table-column>

                <c-table-column
                    label="签批人姓名"
                    name="sign_approval_user_realname"
                ></c-table-column>

				<c-table-column
					label="签批时间"
					name="sign_approval_date"
                    width="150"
                ></c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 0 || data.state == 4 " power="b_member_reward_supdeduct_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button v-if="data.state == 0 || data.state == 4 " power="b_member_reward_supdeduct_edit" @click="del(data)">删除</c-table-button>
						<c-table-button v-if="data.state == 1 || data.state == 2 || data.state == 3"  @click="navigateTo(`/member_reward_supdeduct_detail/${data.id}`)">查看</c-table-button>
						<c-table-button v-if="data.state == 1" power="b_member_reward_supdeduct_approval" @click="navigateTo(`/member_reward_supdeduct_detail/${data.id}`)">审批</c-table-button>
						<c-table-button v-if="data.state == 2" power="b_member_reward_supdeduct_sign" @click="navigateTo(`/member_reward_supdeduct_detail/${data.id}`)">签批</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="uEdit" :title="editState ? '编辑佣金补扣款' : '申请佣金补扣款'" width="600" >
			<c-form ref="uForm">
				<c-form-item type="hidden" name="user_id"></c-form-item>
                <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone" required readonly @click="$refs.memberSelector.open()" placeholder="点击选择补扣款会员"></c-form-item>
                <c-form-item type="input" label="会员昵称" name="nick_name" disabled readonly></c-form-item>
                <c-form-item type="input" label="会员等级" name="user_level_name" disabled readonly></c-form-item>
				<c-form-item type="input" label="佣金账户余额" name="reward_balance" disabled></c-form-item>
				<c-form-item type="radio" label="补扣款类型" name="type" :options="Type" required></c-form-item>
				<c-form-item type="number" label="金额" name="money"  decimal="2" :limit="[0.01,999999]" required></c-form-item>
				<c-form-item type="image" label="凭证" name="voucher_img_url" file-word="" ></c-form-item>
				<c-form-item type="textarea" label="备注" name="remark" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit(0)">保存为草稿</c-button>
				<c-button size="m" @click="submit(1)">保存并提交</c-button>
				<c-button size="m" @click="$refs.uEdit.close()">取消</c-button>
			</template>
		</c-dialog>
		
		<member-selector ref="memberSelector" @resolve="selectMember"></member-selector>
	</page>
</template>

<script>
	import memberSelector from '@/components/service/member_selector.vue'  // 会员库
    import {mapState} from "vuex";  // 会员库

    export default {
		name: 'm_member_reward_supdeduct',
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			memberSelector
		},
        computed: {
            ...mapState(['systemConfig', 'userInfo']),
        },
		data() {
			return {
                workType:6,
                searchParams:{},
				account_type:2,
				stateName: {
					0: '草稿',
					1: '待审批',
					2: '待签批',
					3: '已完成',
					4: '驳回'
				},
				deduction_typeName: {
					1: '违规扣款',
					2: '其他'
				},
				State: [{
						name: '草稿',
						value: 0
					},{
						name: '待审批',
						value: 1
					},{
						name: '待签批',
						value: 2
					},{
						name: '已完成',
						value: 3
					},{
						name: '驳回',
						value: 4
					}
				],
				Type: [{
						name: '补款',
						value: "补款"
					},{
						name: '扣款',
						value: "扣款"
					}
				],
				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('member_reward_supdeduct.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});

		},
		
		methods: {
			searchHandle(data) {
				data.account_type = this.account_type;
				this.$refs.table.load({
					url: '/user/account/sup_deduct/list',
					data
				});
                this.searchParams = data||{};
			},
			add(stop) {
				this.editState = false;
				this.$refs.uForm.clear();
				this.$refs.uEdit.open();
			},
			edit(val) {
				this.editState = true;
				this.$refs.uForm.set(val);
				this.$refs.uEdit.open();
			},
			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.sup_deduct_number+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/user/account/sup_deduct/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			selectMember(data) {
				this.$refs.uForm.set({
					user_id: data[0].platform_user_id,
					user_manage_mobilephone: data[0].user_manage_mobilephone,
					reward_balance: parseFloat(data[0].reward_balance||0).toFixed(2),
                    nick_name: data[0].nick_name,
                    user_level_name: data[0].user_level_name||'普通用户'
				});
			},
			submit(state) {
				//stop();
				let submitUrl = '/user/account/sup_deduct/save';
				if(this.editState){
					submitUrl = '/user/account/sup_deduct/save';
				}
				this.$refs.uForm.submit({
					url: submitUrl,
					rule: {
						user_id: [{
							type: 'empty',
							word: '请选择会员'
						}],

						money: [{
							type: 'empty',
							word: '请输入金额'
						}],
						
						type: [{
							type: 'empty',
							word: '请选择补扣类型'
						}],

						remark: [{
							type: 'empty',
							word: '请填写备注信息'
						}]
					},
					dataFormatter: data => {
						data.account_type = this.account_type;
						data.state = state;
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
						this.$refs.uEdit.close();
					},
				});
			},

            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>